import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BDropdown, BDropdownItem, BInputGroup, BInputGroupAppend, BModal } from "bootstrap-vue";
import { capitalize } from "lodash";
import { computed, onMounted, ref, watch } from "vue";
import { fetchCurrentUserQuotaUsages } from "@/api/users";
import {} from "@/utils/filtering";
import { errorMessageAsString } from "@/utils/simple-error";
import QuotaUsageBar from "@/components/User/DiskUsage/Quota/QuotaUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuDropdown',
    props: {
        type: null,
        name: null,
        error: null,
        filter: null,
        filters: null,
        identifier: null,
        disabled: { type: Boolean }
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faQuestion);
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        watch(() => localValue.value, () => {
            emit("change", props.name, localValue.value);
        });
        watch(() => propValue.value, () => {
            localValue.value = propValue.value;
        });
        // datalist refs
        const datalist = computed(() => props.filter.datalist);
        const stringDatalist = computed(() => {
            if (datalist.value && typeof datalist.value[0] === "string") {
                return datalist.value;
            }
            return [];
        });
        const objectDatalist = computed(() => {
            if (datalist.value && typeof datalist.value[0] !== "string") {
                return datalist.value;
            }
            return [];
        });
        // help modal button refs
        const helpToggle = ref(false);
        const modalTitle = `${capitalize(props.filter.placeholder)} Help`;
        function onHelp(_, value) {
            helpToggle.value = false;
            if (!props.disabled) {
                localValue.value = value;
            }
        }
        // Quota Source refs and operations
        const quotaUsages = ref([]);
        const errorMessage = ref();
        async function loadQuotaUsages() {
            try {
                quotaUsages.value = await fetchCurrentUserQuotaUsages();
                // if the propValue is a string, find the corresponding QuotaUsage object and update the localValue
                if (propValue.value && typeof propValue.value === "string") {
                    localValue.value = quotaUsages.value.find((quotaUsage) => props.filter.handler.converter(quotaUsage) === propValue.value);
                }
            }
            catch (e) {
                errorMessage.value = errorMessageAsString(e);
            }
        }
        const hasMultipleQuotaSources = computed(() => {
            return !!(quotaUsages.value && quotaUsages.value.length > 1);
        });
        onMounted(async () => {
            if (props.type === "QuotaSource") {
                await loadQuotaUsages();
            }
        });
        function isQuotaUsage(value) {
            return !!(value && value instanceof Object && "rawSourceLabel" in value);
        }
        const dropDownText = computed(() => {
            if (props.type === "QuotaSource" && isQuotaUsage(localValue.value)) {
                return localValue.value.sourceLabel;
            }
            if (localValue.value) {
                const stringMatch = stringDatalist.value.find((item) => item === localValue.value);
                const objectMatch = objectDatalist.value.find((item) => item.value === localValue.value);
                if (stringMatch) {
                    return stringMatch;
                }
                else if (objectMatch) {
                    return objectMatch.text;
                }
            }
            return "(any)";
        });
        function setValue(val) {
            localValue.value = val;
        }
        return { __sfc: true, props, emit, propValue, localValue, datalist, stringDatalist, objectDatalist, helpToggle, modalTitle, onHelp, quotaUsages, errorMessage, loadQuotaUsages, hasMultipleQuotaSources, isQuotaUsage, dropDownText, setValue, faQuestion, FontAwesomeIcon, BButton, BDropdown, BDropdownItem, BInputGroup, BInputGroupAppend, BModal, QuotaUsageBar };
    }
});
